var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWorkflowReport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#00A198"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.16 4.668H9.84c-.538 0-.98 0-1.341.03-.375.03-.72.096-1.043.26-.502.256-.91.664-1.165 1.166-.165.324-.23.668-.262 1.043C6 7.527 6 7.97 6 8.507v6.989c0 .536 0 .98.03 1.34.03.375.096.72.26 1.043.256.501.664.91 1.166 1.165.324.165.668.23 1.043.261.36.03.803.03 1.34.03h4.322c.537 0 .98 0 1.34-.03.375-.03.72-.096 1.043-.261.502-.256.91-.664 1.165-1.165.165-.324.23-.668.262-1.043.029-.36.029-.804.029-1.34V8.506c0-.537 0-.98-.03-1.34-.03-.375-.096-.72-.26-1.043a2.667 2.667 0 00-1.166-1.165c-.324-.165-.668-.23-1.043-.262-.36-.029-.803-.029-1.34-.029zm-1.493 4.667a.667.667 0 00-1.334 0V16a.667.667 0 001.334 0V9.335zm2 2c.368 0 .666.298.666.666v4a.667.667 0 11-1.333 0v-4c0-.368.299-.666.667-.666zm-5.334 1.333c.369 0 .667.298.667.667V16a.667.667 0 11-1.333 0v-2.666c0-.369.298-.667.666-.667z",
    fill: "#fff"
  })));
}
export default SvgIconWorkflowReport;